/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-arrow-down-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.75 16.25V15H5.881L16.25 4.631l-.881-.881L5 14.119V6.25H3.75v10z"/>'
  }
})
